module.exports = __webpack_public_path__ + "images/240ce820420a7b874a7d7c92e96fbc82.png";